import { css } from 'react-emotion'

const styles = {
  colors: css({
    display: 'flex',
    alignItems: 'center'
  }),
  label: css({
    cursor: 'pointer',
    marginRight: '4px !important',
    '> .icon': css({
      marginRight: '0 !important'
    })
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentBox/BrushSelectorStyles.js